var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackgroundSkills(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 646,
    height: 671,
    viewBox: "0 0 646 671",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M39.8476 208.968C39.8476 208.968 -2.3582 317.958 56.9512 427.746C116.261 537.535 238.448 595.5 336.237 645.077C434.027 694.655 535.572 670.511 583.828 589.305C632.083 508.098 565.894 450.126 565.816 334.32C565.739 218.514 583.146 187.852 520.452 90.0147C457.757 -7.82447 303.86 -29.4777 187.523 43.0868C71.1874 115.651 39.8476 208.968 39.8476 208.968Z",
    fill: "#F6EDFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4236 166.69C73.8701 88.2056 148.904 28.831 242.443 20.4692C306.103 14.7796 371.492 33.4866 422.201 72.4721C447.728 92.0981 470.415 117.208 485.474 145.815C502.77 178.673 507.802 216.55 525.596 249.247C547.722 289.904 589.263 306.668 617.16 341.801C640.133 370.733 648.017 409.499 645.379 446.348C640.565 513.617 601.154 577.483 543.189 611.956C494.185 641.097 435.111 649.14 378.158 646.493C290.355 642.413 202.933 613.462 133.776 559.209C64.6196 504.957 14.9044 424.765 3.13151 337.66C-4.86998 278.459 6.76208 218.423 33.4236 166.69Z",
    fill: "url(#paint0_linear_25_4697)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_25_4697",
    x1: 323.256,
    y1: 19.4674,
    x2: 323.256,
    y2: 646.966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEFFB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7FFD9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundSkills);
export default __webpack_public_path__ + "static/media/Background_Skills.aef0d05b0e12d680d4d0633587ef62fe.svg";
export { ForwardRef as ReactComponent };